<template>
  <v-card
    class="fin-no-card pa-6 pb-5 ma-3">
    <v-row>
      <v-col lg="6" md="11" cols="12">
        <p :style="`font-size: ${$vuetify.breakpoint.smAndDown ? '17px': '2rem' }`">Erstelle dein erstes Portfolio</p>
        <p style="font-weight: lighter" class="mb-0">Aktueller Wert</p>
        <h1 class="pt-0">0,00€</h1>
      </v-col>
      <v-col lg="6" md="1" class="d-flex justify-end" cols="12">
        <v-img :max-width="$valueByBreakpoint({xs: 180, sm: 260, md: 350, lg: 350, xl: 350})"
               style="z-index: 1"
               :src="require('@/assets/tools/tool-tools-portfolio.svg')" contain/>
      </v-col>
    </v-row>
    <v-row :style="'margin-top:' + $valueByBreakpoint({xs:'-170px', sm:'-275px', md: '-235px', lg: '-275px;', xl: '-275px;'})">
      <v-col offset="1" cols="11">
        <fin-chart2 lg="12"
                    :options="chartOptions" />
      </v-col>
    </v-row>
    <v-row>
      <v-col style="display: grid; justify-self: center;">
        <v-divider style="height: 1rem; border-color: white;"></v-divider>
        <v-btn class="pt-3"
               @click="$emit('showPortfolioDialog')"
               dark
               elevation="0"
               style="height: auto; background-color: transparent !important; font-size: 1rem;"
        >
          <span class="more">Neues Portfolio erstellen</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"
import FinChart2 from "@/components/common/Chart2/FinChart2"

export default {
  name: 'fin-no-portfolio-yet',
  components: {FinChart2},
  props: {},
  data() {
    return {}
  },
  computed: {
    chartOptions() {
      return FinChartBuilder.createPlaceholderChart(this.$finColors.white, this)
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
@import "../../../../styles/variables";

.fin-no-card{
  background-color: $fin-color-accent-blue;

  h1{
    font-family: Gilroy !important;
    font-size:32px;
    font-weight: bold;
    color: white;
  }

  p{
    font-weight: bold;
    color: white;

  }

  ::v-deep .highcharts-area{
    opacity: 0.3 !important;
  }

}


</style>
